





























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ReloadButton from '@/components/BaseReloadButton.vue';
import Grid from '@/components/Grid.vue';
import GridFileItem from '@/components/GridFileItem.vue';
import { FavoriteActions } from '@/store/favorite/actions.enum';
import OpenFileMixin from '@/mixins/open-file';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default Vue.extend({
  name: 'Favorites',

  mixins: [OpenFileMixin],

  components: {
    ReloadButton,
    Grid,
    GridFileItem,
    LoadingSpinner,
  },

  computed: {
    ...mapGetters('favorite', ['items', 'loading']),
  },

  methods: {
    ...mapActions('favorite', { fetchFavorites: FavoriteActions.GET_ALL }),

    reload() {
      this.fetchFavorites();
    },
  },
});
